import styled from "styled-components"

interface CardImageProps {
  isSquare: boolean
}

export const CardImageContainer = styled.div`
  position: relative;
  width: 50px;
  height: 95px;
  padding: 16px 0 16px 0;
`

export const IconWrapper = styled.div`
  position: absolute;
  right: -5px;
  bottom: ${({theme}) => theme.spacing.two};
`

export const Image = styled.img<CardImageProps>`
  height: 48px;
  width: 48px;
  border-radius: ${({isSquare}) => (isSquare ? "10px" : "40px")};
`
